import { FC } from 'react';

import { Path, Svg, type SvgProps } from './svg';

export const UserEdit: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
			fill="currentColor"
		/>
		<Path
			d="M2 21V19C2 16.7909 3.79086 15 6 15H10"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M18 13.8175L21 16.8175M12 22.3175V19.8175L19.5 12.3175C20.19 11.6275 21.31 11.6275 22 12.3175L22.5 12.8175C23.19 13.5075 23.19 14.6275 22.5 15.3175L15.5 22.3175H12Z"
			stroke="currentColor"
			strokeWidth="1.7"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Svg>
);
